import { render, staticRenderFns } from "./ClaimDetailQuery.vue?vue&type=template&id=54736648&"
import script from "./ClaimDetailQuery.vue?vue&type=script&lang=js&"
export * from "./ClaimDetailQuery.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDetailQuery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimDetailQuery.vue"
export default component.exports